import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  icon: "menu_book",
  clients: [],
  client: {},
  clientContacts: [],
  sites: [],
  site: {},
  buildings: [],
  building: {},
  plants: [],
  plant: {}
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
